<template lang="pug">
aside-modal(id="tradingAreaModal", width="w-xxxl", :loading="loading")
    span(slot="header-text") {{ tradingAreaExists ? 'Update' : 'Create' }} Trading Area
    div.p-a(slot="body")
        form(id="tradingAreaForm")
            fieldset(:disabled="loading")
                div.md-form-group
                    input.md-input(
                        type="text",
                        v-model="trading_area.name",
                        :readonly="!canManageTradingArea"
                        required
                    )
                    label Name

                div.md-form-group
                    label {{ trans('general.outlets') }}
                    multiselect(
                        v-model="trading_area.outlets",
                        label="name",
                        track-by="id",
                        placeholder="Type to search",
                        :options="outletList",
                        :multiple="true",
                        :close-on-select="false",
                        :hide-selected="false",
                        :max-height="400",
                        :limit="30",
                        :loading="outlets_loading"
                        @search-change="loadOutlets"
                        :disabled="!canManageTradingArea"
                    )

    button.btn.btn-fw.primary(
        slot="footer",
        @click="submit()",
        :disabled="onLoading('save-trading-area')"
        v-if="canManageTradingArea"
    ) 
        v-loading(loader="save-trading-area") Save
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Auth from '@js/plugins/auth';

export default {
    data() {
        return {
            trading_area: null,
            outletList: [],
            outlets_loading: false,
        };
    },

    computed: {
        activeOutlet() {
            return this.$store.getters.activeOutlet;
        },
        loading() {
            return (
                this.onLoading('fetch-trading-area') ||
                this.onLoading('save-trading-area')
            );
        },

        tradingAreaExists() {
            return this.trading_area.id !== null;
        },

        canManageTradingArea() {
            return Auth.hasPermissionTo('franchise_manage_trading_area');
        },
    },

    created() {
        this.trading_area = this.newTradingArea();
    },

    mounted() {
        this.loadOutlets();
        this.registerEvent();
    },

    methods: {
        ...mapActions('tradingArea', [
            'getTradingArea',
            'updateTradingArea',
            'createTradingArea',
        ]),

        newTradingArea() {
            return {
                id: null,
                name: null,
                outlets: [],
            };
        },

        toggleModal(action) {
            $('#tradingAreaModal').modal(action);
        },

        getOultetList() {
            let api = Laroute.route('franchise.vue.outlets');
            this.$http.get(api).then(response => {
                this.outlets = response.data.data;
            });
        },

        loadOutlets: _.debounce(function(query) {
            let api = Laroute.route('franchise.vue.outlets');
            let options = {
                params: {
                    query: query,
                    limit: this.multiselect_query_limit,
                },
            };

            this.outlets_loading = true;
            this.$http.get(api, options).then(response => {
                this.outletList = response.data.data;
                this.outlets_loading = false;
            });
        }, 500),

        registerEvent() {
            this.$on('show-trading-area', id => {
                if (this.loading) return;

                if (id === null) {
                    this.trading_area = this.newTradingArea();
                    this.toggleModal('show');
                } else {
                    this.getTradingArea(id)
                        .then(res => {
                            this.toggleModal('show');
                            this.trading_area = _.pick(res.data, [
                                'id',
                                'name',
                                'outlets',
                            ]);
                        })
                        .catch(err => {
                            this.showApiError(err);
                        });
                }
            });
        },

        submit() {
            /** Promise */
            let save;

            if (!this.validateForm('tradingAreaForm')) return;

            const outlets = this.trading_area.outlets.map(p => p.id);

            const trading_area = Object.assign(
                _.pick(this.trading_area, ['id', 'name']),
                {
                    outlets,
                },
            );

            if (!this.tradingAreaExists) {
                save = this.createTradingArea(trading_area);
            } else {
                save = this.updateTradingArea(trading_area);
            }

            save.then(res => {
                this.showToastrSuccess();

                if (this.tradingAreaExists) {
                    this.toggleModal('hide');
                } else {
                    this.trading_area = this.newTradingArea();
                }

                this.$emit('trading-area-saved');
            }).catch(err => {
                this.showApiError(err);
            });
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/trading-area/trading-area-form.vue